import {
    ENTER_EMAIL,
    ENTER_SUBJECT,
    ENTER_MESSAGE,
    SET_RECAPTCHA_TOKEN,
    CLEAR_FORM,
    SELECT_FILE,
    SENDING_REPORT_START,
    SENDING_REPORT_SUCCESS,
    SENDING_REPORT_ERROR,
} from '../actions/report';

const initialState = {
    email: null,
    subject: '',
    message: '',
    reCaptchaToken: '',
    file: null,
    error: null,
    status: {
        error: false,
        fetching: false,
        loaded: false,
    },
};

export const reducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case ENTER_EMAIL:
            return {
                ...state,
                email: action.payload,
            };
        case ENTER_SUBJECT:
            return {
                ...state,
                subject: action.payload,
            };
        case ENTER_MESSAGE:
            return {
                ...state,
                message: action.payload,
            };
        case SET_RECAPTCHA_TOKEN:
            return {
                ...state,
                reCaptchaToken: action.payload,
            };
        case SELECT_FILE:
            return {
                ...state,
                file: action.payload,
            };
        case CLEAR_FORM:
            return {
                ...state,
                email: null,
                subject: '',
                message: '',
                reCaptchaToken: '',
                file: null,
                error: null,
                status: {
                    error: false,
                    fetching: false,
                    loaded: false,
                },
            };
        case SENDING_REPORT_START:
            return {
                ...state,
                status: {
                    error: false,
                    fetching: true,
                    loaded: false,
                },
            };
        case SENDING_REPORT_SUCCESS:
            return {
                ...state,
                status: {
                    error: false,
                    fetching: false,
                    loaded: true,
                },
            };
        case SENDING_REPORT_ERROR:
            return {
                ...state,
                status: {
                    error: true,
                    fetching: false,
                    loaded: false,
                },
            };
        default:
            return {
                ...state,
            };
    }
};
